import { IGameDetailsResponse, IGame, GameType } from 'protos'

const isGame = (subject?: unknown): subject is IGame => {
  return !!subject && Object.keys(subject as Object).includes('gameId')
}

const isGameDetails = (subject?: unknown): subject is IGameDetailsResponse => {
  return !!subject && Object.keys(subject as Object).includes('game')
}

export default (subject?: IGameDetailsResponse | IGame | null) => {
  if (isGame(subject)) {
    return subject.type === GameType.GT_CLASSIC
  }

  if (isGameDetails(subject)) {
    return !!subject.game && subject.game.type === GameType.GT_CLASSIC
  }

  return false
}
try {
    // @ts-ignore
    isClassicGame.displayName = "isClassicGame";
    // @ts-ignore
    isClassicGame.__docgenInfo = { "description": "", "displayName": "isClassicGame", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/lib/isClassicGame.ts#isClassicGame"] = { docgenInfo: isClassicGame.__docgenInfo, name: "isClassicGame", path: "src/lib/isClassicGame.ts#isClassicGame" };
}
catch (__react_docgen_typescript_loader_error) { }